import { Avatar, Stack, Typography } from '@mui/material';
import { shortDateFormat } from 'Config';
import { format } from 'date-fns';
import { useIsDesktop } from 'Hooks';
import { WhiteX } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ICategory {
  searchValue?: string | number | Date;
  removeSearchCategory: Function;
  searchValueID?: number;
  subValueFieldID?: number;
}

export const Category = ({
  searchValue,
  removeSearchCategory,
  searchValueID,
  subValueFieldID,
}: ICategory) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      onClick={(event) =>
        removeSearchCategory(event, searchValueID, subValueFieldID)
      }
      onKeyDown={onEnterOrEscapeKeyDown}
      tabIndex={0}
      sx={{
        alignItems: 'center',
        width: 'fit-content',
        bgcolor: 'purple2.main',
        color: '#fff',
        padding: isDesktop ? '6px 12px 6px 16px' : '6px 8px 6px 16px',
        borderRadius: '6px',
        gap: '6px',
        ':hover': { cursor: 'pointer' },
      }}
    >
      <Avatar
        alt=''
        src={WhiteX}
        sx={
          isDesktop
            ? { width: '12px', height: '20px' }
            : { width: '12px', height: '20px' }
        }
      />
      <Typography variant={'body6'}>
        {searchValue instanceof Date
          ? format(searchValue, shortDateFormat)
          : searchValue}
      </Typography>
    </Stack>
  );
};
